// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"37445464","535":"2bb35c90"}[chunkId] + ".chunk.js";
};